import React, { useEffect, useState } from "react";
import { useTripStore } from "../Reports/SATReports/store/useTripStore";
import MUITable from "../../Common/MUITable";
import { useNavigate } from "react-router-dom";
import Loader from "../../Common/Loader/loader";
import useIndependentStore from "./store/independentEngineerStore";
import { useDropdownStore } from "../AssetVehicle/store/useDropdownStore";
import IndependentEngineerModal from "./IndependentEngineerModal";
import { useFilterStore } from "../AssetVehicle/store/useFilterStore";
import isGHMC from "../../Common/helper/helpar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { ExportHygieneData } from "../HygieneObservation/ExportHygieneData";
import { ExportIndependentEngineerData } from "./ExportIndependentEnginnerData";

export const IndependentEngineer = () => {
    const { independentEngineerData, loading, error, ieNameList, fetchindependentEngineerData, selectedIEName, selectedStatus, setStatus, setSelectedIEName, deleteIndependentEngineerStore } = useIndependentStore();
    const [selectedEngineerData, setSelectedEngineerData] = useState(null);
    const [modalShow, setModalShow] = useState(false);
    const isProd = isGHMC();

    let storedPermissions = localStorage.getItem("permissionId");
    const permissionValues1 =
        JSON.parse(localStorage.getItem("rolePermissions")) || {};
    let canWriteValue = null;

    // Convert storedPermissions to a number (if needed)
    storedPermissions = parseInt(storedPermissions, 10);

    // Find the matching roleToPermissionMapping object
    const matchingPermission = permissionValues1.find(
        (mapping) => mapping.permissionId === storedPermissions
    );

    if (matchingPermission) {
        canWriteValue = matchingPermission.canWrite;
        console.log(
            `canWrite value for permission ID ${storedPermissions}:`,
            canWriteValue
        );
    } else {
        console.log(`No match found for permission ID ${storedPermissions}`);
    }

    useEffect(() => {
        fetchindependentEngineerData()
    }, [])

    const handleSearch = () => {
        fetchindependentEngineerData({
            ieName: selectedIEName || '',
            isActive: selectedStatus !== "" ? selectedStatus : '',
        });
    };


    const IEWiseHeaderColumns = [
        {
            label: "Name",
            field: "name",
            render: (row) => <div style={{ fontWeight: "500" }}>{row.name}</div>,
        },
        {
            label: "IE Engineer ID",
            field: "ieEngineerId",
        },
        {
            label: "Associated Transfer Station",
            field: "associatedTransferStationNames",
            render: (row) => row.associatedTransferStationNames?.join(", ") || "-",
        },
        {
            label: "Status",
            field: "isActive",
            render: (row) => (row.isActive ? "Active" : "InActive"),
        },
        {
            label: "Action",
            field: "action",
            render: (row, index) => (
                <div className="d-flex gap-2 justify-content-center">
                    <button className={`${index % 2 === 0 ? "bg-F8CCCD" : "bg-ddefff"}
                      ${isProd ? "edit-ghmc" : "edit-swm"}`} onClick={() => {
                            setSelectedEngineerData(row);
                            setModalShow(true);
                        }}>
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                    {/* <button className={`${index % 2 === 0 ? "bg-F8CCCD" : "bg-ddefff"}
                        ${isProd ? "edit-ghmc" : "edit-swm"}`} onClick={() => handleDelete(row.engineerId)}>
                        <FontAwesomeIcon icon={faTrash} />
                    </button> */}
                </div>
            ),
        },
    ];

    // const handleDelete = (engineerId) => {
    //     Swal.fire({
    //         title: "Are you sure?",
    //         text: "You won't be able to revert this data!",
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#d33",
    //         cancelButtonColor: "#3085d6",
    //         confirmButtonText: "Yes, delete it!",
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             deleteIndependentEngineerStore(engineerId)
    //                 .then(() => {
    //                     Swal.fire({
    //                         title: "Deleted!",
    //                         text: "Independent Engineer has been deleted.",
    //                         icon: "success",
    //                         timer: 2000,
    //                         showConfirmButton: false,
    //                     });
    //                     fetchindependentEngineerData(); // Refresh data
    //                 })
    //                 .catch((error) => {
    //                     console.error("Error deleting Independent Engineer:", error);
    //                     Swal.fire("Error", "Failed to delete Independent Engineer.", "error");
    //                 });
    //         }
    //     });
    // };


    return (
        <div style={{ width: "100%" }}>
            <div className="content">
                <div className="page-content">
                    <div className="d-flex justify-content-between align-items-end  mt-3">
                        {/* Filters and Search Button */}
                        <div className="d-flex align-items-end gap-2">
                            <div style={{ width: "200px" }}>
                                <div className="form-group-filter">
                                    <label className="form-label" style={{ marginBottom: "-2px" }}>IE Name</label>
                                    <input
                                        type="text"
                                        className="form-control bg-white"
                                        value={selectedIEName}
                                        onChange={(e) => setSelectedIEName(e.target.value)}
                                        placeholder="Search IE Name"
                                    />
                                </div>
                            </div>

                            <div style={{ width: "200px" }}>
                                <div className="form-group-filter">
                                    <label className="form-label" style={{ marginBottom: "-2px" }}>Status</label>
                                    <select
                                        className="form-select bg-white"
                                        value={selectedStatus}
                                        onChange={(e) => setStatus(e.target.value)}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="true">Active</option>
                                        <option value="false">Inactive</option>
                                    </select>
                                </div>
                            </div>

                            {/* Search Button */}
                            <div className="col-md-2">
                                <button
                                    onClick={handleSearch}
                                    className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                                >
                                    Search
                                </button>
                            </div>
                        </div>

                        {/* Export Button Centered */}
                        <div className="d-flex justify-content-between">
                            {/* {canWriteValue === true ? ( */}
                            <button
                                className="btn d-flex align-items-center"
                                onClick={() => setModalShow(true)}
                                style={{
                                    backgroundColor: "#fff",
                                    color: "#333333",
                                    borderRadius: "20px",
                                    padding: "6px 12px",
                                    border: "1px solid #CCCCCC",
                                }}
                            >
                                <i className="fa-solid fa-plus me-1"></i> Add Independent Engineer
                            </button>
                            {/* ) : (
                                ""
                              )} */}
                            <ExportIndependentEngineerData />
                        </div>
                    </div>

                    {/* Data Table Section */}
                    <div className="card mt-3">
                        <div className="card-body">
                            <div className="top-header">
                                <span className="m-0">Independent Engineer</span>
                            </div>
                            {loading && <Loader />}
                            <MUITable
                                needSRNumber
                                columns={IEWiseHeaderColumns}
                                rows={independentEngineerData}
                                tableHeight={500}
                            />
                        </div>
                        <IndependentEngineerModal
                            show={modalShow}
                            handleClose={() => {
                                setModalShow(false)
                                setSelectedEngineerData(null);
                            }}
                            selectedEngineerData={selectedEngineerData}

                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
